import React, { useState } from 'react';
import Tabs from '../../../../components/base/tabs';
import BeneficiarySetup from '../../../../components/settings/kyb-updates/beneficiary-setup';
import BusinessInformation from '../../../../components/settings/kyb-updates/business-information';
import KybUpdateVerification from '../../../../components/settings/kyb-updates/verification';
import KybUpdateChangeRequest from '../../../../components/settings/kyb-updates/change-request';
import KybUpdateConfirmation from '../../../../components/settings/kyb-updates/confirmation';

const KybUpdate = () => {
  const [currentTab, setCurrentTab] = useState('Business information');

  const handleTabChange = (tab: string) => {
    setCurrentTab(tab);
  };

  return (
    <div className="grid gap-5">
      <div>
        <p className="ryno_text_heading">KYB Updates</p>
        <p className="ryno_text_medium">Settings</p>
      </div>

      <div className="mb-4">
        <Tabs
          tabs={[
            'Business information',
            'Beneficiary Setup',
            'Verification',
            'Change Request(s)',
            'Confirmation',
          ]}
          activeTab={currentTab}
          onTabChange={handleTabChange}
          type="secondary"
        />
      </div>

      <div className="mb-8">
        {currentTab === 'Business information' && <BusinessInformation />}
        {currentTab === 'Beneficiary Setup' && <BeneficiarySetup />}
        {currentTab === 'Verification' && <KybUpdateVerification />}
        {currentTab === 'Change Request(s)' && <KybUpdateChangeRequest />}
        {currentTab === 'Confirmation' && <KybUpdateConfirmation />}
      </div>
    </div>
  );
};

export default KybUpdate;
